<div
  class="page-select"
  [class.page-select--compact]="sizeMin"
  [class.page-select--flat]="removeBackground">
  <div class="page-select__nav">
    <button
      type="button"
      class="page-select__arrow"
      aria-label="Página anterior"
      [class.page-select__arrow--hidden]="pages <= 1"
      [disabled]="pages <= 1 || selectedPage <= 1"
      (click)="changePag('-')">
      <mat-icon class="page-select__arrow-icon" svgIcon="Chevron Left"></mat-icon>
    </button>

    <div class="page-select__page-input">
      <span class="page-select__label">Página</span>
      <input
        class="page-select__input"
        type="text"
        inputmode="numeric"
        [(ngModel)]="selectedPage"
        [disabled]="maxPages === 1"
        (keyup)="verifySelectedValue()"
        (change)="switchToThisPage(selectedPage)">
      <span class="page-select__label">de {{ maxPages }}</span>
    </div>

    <button
      type="button"
      class="page-select__arrow"
      aria-label="Próxima página"
      [class.page-select__arrow--hidden]="pages <= 1"
      [disabled]="pages <= 1 || selectedPage >= pages"
      (click)="changePag('+')">
      <mat-icon class="page-select__arrow-icon" svgIcon="Chevron Right"></mat-icon>
    </button>
  </div>

  @if (!sizeMin) {
    <div class="page-select__summary">
      <span class="page-select__label">Exibindo</span>

      <div class="page-size-select">
        <mat-select
          #selectPage
          class="page-size-select__control"
          panelClass="page-select-panel"
          hideSingleSelectionIndicator
          [formControl]="select"
          (selectionChange)="onPageSizeSelectionChange($event.value)">
          <mat-select-trigger>
            <span class="page-size-select__value">{{ displayedItemCount }} itens</span>
          </mat-select-trigger>

          @for (item of visiblePageSizeOptions; track item) {
            <mat-option [value]="item">{{ item }} itens</mat-option>
          }
        </mat-select>
      </div>

      <span class="page-select__results">
        de <strong>{{ length }}</strong> resultados
      </span>
    </div>
  }
</div>
